import { Language } from '@ha/intl';

const availableLocales = [Language.nl, Language.de];

export default (lang: Language) => availableLocales.includes(lang);
